import {
  ChangeDetectionStrategy,
  Component,
  HostListener,
  inject,
  signal,
  OnDestroy,
  computed,
  effect,
  input,
} from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';
import { CommonModule } from '@angular/common';
import { TreeModule } from 'primeng/tree';
import { Divider } from 'primeng/divider';
import { MessageService, TreeNode } from 'primeng/api';
import { NgIcon, provideIcons } from '@ng-icons/core';
import {
  lucideLogOut,
  lucidePhone,
  lucideHouse,
  lucideUsers,
  lucideUser,
  lucideChartLine,
  lucideSwatchBook,
  lucideBuilding2,
  lucideLamp,
  lucideLightbulb,
  lucideAlbum,
  lucideActivity,
  lucideLaptop2,
  lucideLogs,
  lucideListChecks,
} from '@ng-icons/lucide';
import { environment } from '../../../../environments/environment';
import { Subscription } from 'rxjs';
import { BadgeModule } from 'primeng/badge';
import { RouterModule } from '@angular/router';
import { PopoverModule } from 'primeng/popover';
import { NavBarService } from '../nav-bar.service';
import { DrawerModule } from 'primeng/drawer';
import { ButtonModule } from 'primeng/button';
import { AuthService } from '../../../core/services/auth.service';
import { navbarItems } from '../../header/navbar-items';
import { PersianTitlesService } from '../../../core/services/persian-titles.service';
@Component({
  selector: 'app-navigation-drawer',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    TreeModule,
    Divider,
    NgIcon,
    BadgeModule,
    PopoverModule,
    DrawerModule,
    ButtonModule,
  ],
  templateUrl: './navigation-drawer.component.html',
  styleUrls: ['./navigation-drawer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [
    provideIcons({
      lucideLogOut,
      lucidePhone,
      lucideHouse,
      lucideUsers,
      lucideUser,
      lucideChartLine,
      lucideSwatchBook,
      lucideBuilding2,
      lucideLightbulb,
      lucideAlbum,
      lucideLaptop2,
      lucideListChecks,
    }),
  ],
  animations: [
    trigger('slideDown', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(-8px)' }),
        animate(
          '150ms ease-out',
          style({ opacity: 1, transform: 'translateY(0)' }),
        ),
      ]),
      transition(':leave', [
        animate(
          '120ms ease-in',
          style({ opacity: 0, transform: 'translateY(-8px)' }),
        ),
      ]),
    ]),
    trigger('fadeFast', [
      transition(':enter', [
        style({ opacity: 0, transform: 'scale(0.96)' }),
        animate('120ms ease-out', style({ opacity: 1, transform: 'scale(1)' })),
      ]),
      transition(':leave', [
        animate(
          '90ms ease-in',
          style({ opacity: 0, transform: 'scale(0.98)' }),
        ),
      ]),
    ]),
    trigger('fadeBackdrop', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('150ms ease-out', style({ opacity: 1 })),
      ]),
      transition(':leave', [animate('120ms ease-in', style({ opacity: 0 }))]),
    ]),
  ],
})
export class NavigationDrawerComponent implements OnDestroy {
  modalOpen = input<boolean>(false);
  navBarService = inject(NavBarService);
  authService = inject(AuthService);
  isOpen = this.navBarService.isNavDrawerOpen;
  isOpenMobile = this.navBarService.isNavDrawerOpenMobile;
  baseApi = environment.baseApi;
  avatarUrl = signal<string>('');
  private imageSubscription: Subscription | null = null;
  navBarItems = navbarItems(this.persianTitlesService);
  messageService = inject(MessageService);

  constructor(private persianTitlesService: PersianTitlesService) {
    effect(() => {
      console.log(this.isOpenMobile());
    });
  }

  callSupportExpanded = signal(false);

  ngOnDestroy() {}

  toggle(): void {
    this.isOpen.update((v) => !v);
    this.items.update((v) => v.map((item) => ({ ...item, expanded: false })));
  }

  closeMenusAfterNavigation(): void {
    if (this.modalOpen()) return;
    if (this.isOpenMobile()) {
      this.isOpenMobile.set(false);
    } else if (this.isOpen()) {
      this.isOpen.set(false);
    }
    this.items.update((v) => v.map((item) => ({ ...item, expanded: false })));
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    if (this.isOpen()) this.isOpen.set(false);
  }

  items = signal<TreeNode[]>(this.buildMenuItems());

  private buildMenuItems(): TreeNode[] {
    const allItems: TreeNode[] = [
      {
        label: 'صفحه اصلی',
        icon: 'lucideHouse',
        type: 'parent',
        data: {
          link: ['/'],
        },
      },
      {
        label: 'تکمیل اطلاعات موسسه',
        icon: 'lucideBuilding2',
        type: 'parent',
        data: {
          link: ['/organization-forms'],
        },
      },
    ];

    return this.navBarItems.map((e) => {
      return {
        id: e.id,
        label: e.name,
        icon: e.icon,
        data: {
          link: e.urlParts,
        },
        children: e.items?.map((se) => {
          return {
            id: se.id,
            label: se.name,
            data: {
              link: se.urlParts,
            },
          };
        }),
      };
    });
  }

  logout() {
    this.authService.logout();
  }

  isArray(a: any) {
    return Array.isArray(a);
  }
  collapseAllItems() {
    this.items.update((v) => v.map((item) => ({ ...item, expanded: false })));
    this.navBarService.isNavDrawerOpenMobile.set(false);
  }
}
